import React, { useEffect, useState } from 'react'
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete'
import { useFormState, useForm } from 'react-final-form'
import _ from 'lodash'
import { TextInput } from 'react-admin'
import GoogleAutocomplete from '../GoogleAutocomplete'
import { Grid } from '@mui/material'

const PropertyAddressInput = () => {
  const { values } = useFormState()

  const form = useForm()

  const [address, setAddress] = useState(
    `${values?.address?.street}, ${values?.address?.street_number}, ${values?.address?.zip} ${values?.address?.city} ${values?.address?.province}, ${values?.address?.country}`,
  )
  const [location, setLocation] = useState(null)

  useEffect(() => {
    if (window.google && location) {
      geocodeByAddress(location.description).then(async (results) => {
        const { address_components } = results[0]
        const { lat, lng } = await getLatLng(results[0])
        const street = _.get(
          _.find(address_components, (item) => _.includes(item.types, 'route')),
          'long_name',
          '',
        )
        const street_number = _.get(
          _.find(address_components, (item) => _.includes(item.types, 'street_number')),
          'long_name',
          '',
        )
        const city = _.get(
          _.find(address_components, (item) => _.includes(item.types, 'administrative_area_level_3')),
          'long_name',
          '',
        )
        const zip = _.get(
          _.find(address_components, (item) => _.includes(item.types, 'postal_code')),
          'long_name',
          '',
        )
        const province = _.get(
          _.find(address_components, (item) => _.includes(item.types, 'administrative_area_level_2')),
          'short_name',
          '',
        )
        const country = _.get(
          _.find(address_components, (item) => _.includes(item.types, 'country')),
          'long_name',
          '',
        )
        form.change('address.lat', lat)
        form.change('address.lng', lng)
        form.change('address.street', street)
        form.change('address.street_number', street_number)
        form.change('address.city', city)
        form.change('address.zip', zip)
        form.change('address.province', province)
        form.change('address.country', country)

        setAddress(location.description)
      })
    }
  }, [location])

  return (
    <Grid item mb={4}>
      <div style={{ visibility: 'hidden', height: '0' }}>
        <TextInput type="hidden" source="address.street" label={false} />
        <TextInput type="hidden" source="address.street_number" label={false} />
        <TextInput type="hidden" source="address.zip" label={false} />
        <TextInput type="hidden" source="address.city" label={false} />
        <TextInput type="hidden" source="address.province" label={false} />
        <TextInput type="hidden" source="address.lat" label={false} />
        <TextInput type="hidden" source="address.lng" label={false} />
        <TextInput type="hidden" source="address.country" label={false} />
      </div>

      <GoogleAutocomplete selectedValue={address} onChange={setLocation} />
    </Grid>
  )
}

export default PropertyAddressInput
